module.exports = __webpack_public_path__ + "img/icon-add-dark.a369a5ed.svg";